
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 2"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1 2h14a1 1 0 000-2H1a1 1 0 000 2z","fill":"#384241"}})])
          )
        }
      }
    